import React from "react";
import { Tabs, Tab, Row, Col } from "react-bootstrap";

const tabData = [
  {
    eventKey: "broadcast",
    title: "Broadcast & Media",
    heading: "Broadcast & Media",
    desc: (
      <>
        <p className="para">
          We help TV networks, OTT platforms, and content owners distribute,
          monetize, and protect content worldwide. Playout, cloud, and
          compliance services. OTT-ready workflows with CDN, DRM, and multi-cam
          delivery. Trusted reliability for linear, VOD, and digital-first
          audiences.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol1.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
  {
    eventKey: "sports",
    title: "Sports & Live Events",
    heading: "Sports & Live Events",
    desc: (
      <>
        <p className="para">
          We help TV networks, OTT platforms, and content owners distribute,
          monetize, and protect content worldwide. Playout, cloud, and
          compliance services. OTT-ready workflows with CDN, DRM, and
          multi-platform delivery. Trusted reliability for linear, VOD, and
          digital-first audiences.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol2.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
  {
    eventKey: "telecom",
    title: "Telecom & ISPs",
    heading: "Telecom & ISPs",
    desc: (
      <>
        <p className="para">
          We partner with carriers, mobile operators, and ISPs to extend their
          reach and resilience. Fiber/IP backbone and Tier-1 IP transit.
          Wholesale backhaul and network redundancy. Satellite VSAT, LEO, and
          MEO services for remote regions.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol3.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
  {
    eventKey: "enterprise",
    title: "Enterprise & Corporate",
    heading: "Enterprise & Corporate",
    desc: (
      <>
        <p className="para">
          We connect enterprises in banking, retail, energy, mining, and remote
          industries with secure, scalable solutions. IoT connectivity, asset
          tracking, and data analytics. Secure WAN, SD-WAN, and hybrid networks.
          Cloud archiving, disaster recovery, and compliance services.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol4.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
  {
    eventKey: "maritime",
    title: "Maritime & Aviation",
    heading: "Maritime & Aviation",
    desc: (
      <>
        <p className="para">
          We enable fleets, vessels, and aircraft to stay connected anywhere in
          the world. Broadband-over-satellite for crew, passengers, and
          operations. VSAT hub platforms for maritime and aero. IoT-enabled
          tracking and monitoring of critical assets.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol5.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
  {
    eventKey: "government",
    title: "Government & Defence",
    heading: "Government & Defence",
    desc: (
      <>
        <p className="para">
          We provide secure, mission-critical communications and broadcast
          services for public and defense organizations. Encrypted satellite &
          IP distribution. Disaster recovery and emergency broadcasting. Secure
          media management with DRM and conditional access.
        </p>
        <h2 className="sec-head xsm">Why Choose Us Across Industries</h2>
        <ul className="srv-dist-card-list like-para">
          <li>End-to-end services: from creative to playout to delivery.</li>
          <li>
            Multi-industry expertise proven across broadcast, enterprise,
            telecom, and government.
          </li>
          <li>
            Global infrastructure spanning satellite, cloud, and IP networks.
          </li>
          <li>
            24/7 operations and monitoring for mission-critical reliability
          </li>
        </ul>
      </>
    ),
    image: "/o-sol6.png", // Use the actual image path in your public folder
    imageAlt: "Broadcast & Media Satellite Dish",
  },
];

const TabsSec = ({ solutionKey }) => {
  return (
    <section className="main-services-sec">
      <div className="container">
        <Tabs
          defaultActiveKey={solutionKey || "broadcast"}
          id="solutions-tabs"
          className="mb-3 cc-tabs"
        >
          {tabData.map((tab) => (
            <Tab eventKey={tab.eventKey} title={tab.title} key={tab.eventKey}>
              <Row className="align-items-start">
                <Col md={6} className="mb-4 mb-md-0">
                  <h2 className="sec-head color-red">{tab.heading}</h2>
                  {tab.desc}
                </Col>
                <div className="col-lg-5 offset-lg-1 col-12">
                  <img
                    src={tab.image}
                    alt={tab.imageAlt}
                    className="w-100 h-auto"
                  />
                </div>
              </Row>
            </Tab>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default TabsSec;
